(function () {
    'use strict';

    angular
        .module('sod.helper')
        .factory('RequestHelper', RequestHelper);

    function RequestHelper(lodash, GenericModel) {
        const urlReplacerRegex = /<([\w.]*)>/g;
        return {
            getNeeded: getNeeded,
            prepareDatasource: prepareDatasource,
        };

        function getNeeded(model, needed) {
            let result = {};
            angular.forEach(needed, (val) => {
                const valArr = val.split('.');
                const modelValue = lodash.get(model, val, '');
                const modelIndex = valArr[valArr.length - 1];
                lodash.set(result, modelIndex, modelValue);
            });

            return result;
        }

        function prepareDatasource(datasource, data) {
            let endpoint = datasource.url;

            const method = lodash.get(datasource, 'method', 'get');
            endpoint = decodeURI(endpoint).replace(urlReplacerRegex, (match, submatch) => {
                return lodash.get(data, submatch, '');
            });

            const resource = new GenericModel(endpoint);

            if (method === 'get') {
                return resource[method](data).$promise;
            } else {
                return resource[method]({}, {data:data}).$promise;
            }
        }
    }
})();